import { BORROW, DEPOSIT, REPAY, WITHDRAW } from "@/utils/constants"
import { ObligationReserveType } from "@/utils/dataTypes"
import { SelectChangeEvent } from "@mui/material"
import { SupplyToEarnApy, SupplyToEarnReward } from "@renec-foundation/relend-adapter"

export type SelectBorrowHeader = {
  value: string
  title: string
}

export enum BORROW_HEADER_VALUES {
  apr = "apr",
  apy = "apy",
}

export type ViewProps = {
  tab: typeof DEPOSIT | typeof BORROW
  handleTabChange: (_event: React.SyntheticEvent, newTab: typeof DEPOSIT | typeof BORROW) => void
  doesHaveSupply: boolean
  doesHaveBorrow: boolean
  supplyToEarnApys: SupplyToEarnApy[]
  supplyToEarnRewards: SupplyToEarnReward[]
  handleOpenSupplyWithdrawPopup: (item: ObligationReserveType, type: typeof DEPOSIT | typeof WITHDRAW) => void
  selectedBorrowHeader: string
  borrowHeaderAprSelectItems: SelectBorrowHeader[]
  handleChangeSelectHeader: (event: SelectChangeEvent) => void
  handleOpenBorrowRepayPopup: (item: ObligationReserveType, type: typeof BORROW | typeof REPAY) => void
}

export type ReserveClaimTokenType = {
  reserveSymbol: string
  rewardSymbol: string
  reserveDecimals: number
  totalRewardAmount: number
}
